type ViaCep = { cep: string; logradouro: string; bairro: string; localidade: string; uf: string; erro?: boolean }
type BrasilApiCep = { cep: string; street: string; neighborhood: string; city: string; state: string }

async function geocodeWithNominatim(query: string) {
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(query)}`
    const res = await fetch(url, {
      headers: {
        Accept: 'application/json',
        'Accept-Language': 'pt-BR',
        'Access-Control-Allow-Origin': 'true',
      },
    })

    if (!res.ok) return null

    const data = (await res.json()) as { lat: string; lon: string }[]
    if (!data.length) return null
    return { lat: Number(data[0].lat), lon: Number(data[0].lon) }
  } catch {
    return null
  }
}

async function getAddressFromCep(cep: string) {
  // 1) tenta BrasilAPI
  try {
    const r = await fetch(`https://brasilapi.com.br/api/cep/v1/${cep}`)
    if (r.ok) {
      const j = (await r.json()) as BrasilApiCep
      return `${j.street}, ${j.neighborhood}, ${j.city} - ${j.state}, Brasil`
    }
  } catch {}

  // 2) fallback ViaCEP
  const r2 = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
  const j2 = (await r2.json()) as ViaCep
  if (j2.erro) return null

  return `${j2.logradouro}, ${j2.bairro}, ${j2.localidade} - ${j2.uf}, Brasil`
}

export default async function getLatLonWithZipCode({ zipCode, setLoading }: { zipCode: string; setLoading: any }) {
  setLoading(true)
  try {
    const cep = zipCode.replace(/\D/g, '')
    if (cep.length !== 8) return null

    console.log('cep: ', cep)

    // CEP -> Endereço
    const addressQuery = await getAddressFromCep(cep)
    if (!addressQuery) return null

    console.log('addressQuery: ', addressQuery)

    // Endereço -> lat/lon
    const coords = await geocodeWithNominatim(addressQuery)
    if (!coords) return null

    console.log('coords: ', coords)

    return { lat: coords.lat, lon: coords.lon, goToTheLocation: true }
  } finally {
    setLoading(false)
  }
}
